import {GuideLevelModelV2} from 'resources/GeneratedModels/GuideLevel/GuideLevelModel.v2';

import {extensions} from './guideLevel.extensions';

GuideLevelModelV2.extend(extensions);

export {GuideLevelModelV2};
